import { Unit } from "uom";
// Alkalinity
export var MilliGramHydrogenCarbonatePerLiter = Unit.createBase("MilliGramHydrogenCarbonatePerLiter", "Alkalinity", "mg HCO₃⁻/l");
//# sourceMappingURL=alkalinity.js.map